import React, { useEffect, useMemo, useState } from 'react'
import "./other-health-problem.scss"
import { Form, Formik } from 'formik';
import { patientOtherHealthProblemAdd } from '../../../service/api/patient-api';
import { useDispatch, useSelector } from 'react-redux';
import { getOtherHealthProblems, getPatientComplaints, getPatientSocialHistoryList } from '../../../store/slices/visitSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePen } from '@fortawesome/free-solid-svg-icons';
import { LocalStorageService } from '../../../utils/local-storage';
const OtherHealthProblem = ({ patientId, visitId }) => {
    const [isSubmitting, setIsSubmitting] = useState(false)
    let { isLoading, otherProblems, noOtherHealthProblem, latestOtherProblem } = useSelector(
        (state) => state.visit
    );
    const [info, setInfo] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const dispatch = useDispatch();
    const setInfoFun = (key, value) => {
        let temp = { ...info };
        setInfo({ ...temp, [key]: value });
        LocalStorageService.set("other-problem", { ...temp, [key]: value })
    };

    useEffect(() => {
        dispatch(getOtherHealthProblems(patientId));
    }, []);
    // useMemo(() => {
    //     if (latestOtherProblem)
    //         setInfo(latestOtherProblem)
    // }, [latestOtherProblem])
    const refresh = () => {
        dispatch(getOtherHealthProblems(patientId));
    }

    const onSubmit = async (values) => {
        let localVal = LocalStorageService.get("other-problem")
        values.problemName = localVal.problemName ? localVal.problemName : info.problemName;
        values.problemDescription = localVal.problemDescription ? localVal.problemDescription : info.problemDescription;
        if (info?._id || localVal._id) values.otherHealthProblemId = localVal._id ? localVal._id : info?._id;
        saveOtherProblemFun(values)

    };

    const saveOtherProblemFun = async (payload) => {
        setIsSubmitting(true)
        await patientOtherHealthProblemAdd(payload, patientId)
            .then((res) => {
                if (res?.status == 200) {
                    setIsSubmitting(false);
                    refresh()
                }
            })
            .catch((error) => {
                setIsSubmitting(false);
                console.log(error);
            });
    }

    const setEditFun = (option) => {
        let textBox = document?.getElementById('other-problem-name')
        if (textBox) textBox.focus()
        LocalStorageService.set("other-problem", option)
        setInfo(option)
    }

    const handleKeyDown = (event) => {
        if ((event.metaKey || event.ctrlKey) && event.key === 's') {
            let localVal = LocalStorageService.get("other-problem")
            event.preventDefault();
            let payload = { problemName: localVal.problemName ? localVal.problemName : info.problemName, problemDescription: localVal.problemDescription ? localVal.problemDescription : info.problemDescription }
            if (!isEditing) {
                saveOtherProblemFun(payload)
            }
            else if (isEditing) {
                if (info?._id || localVal._id) payload.otherHealthProblemId = localVal._id ? localVal._id : info?._id;
                saveOtherProblemFun(payload)
            }
        }
    };

    useEffect(() => {
        if (info)
            document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [info]);

    return (
        <div className='other-health-section'>
            <Formik initialValues={{}} onSubmit={onSubmit}>
                {(formik) => (
                    <div className="">
                        <Form
                            action=""
                            id=""
                            className="custom-form input-section position-relative"
                            encType="multipart/form-data"
                        >
                            <div className="row  ">
                                <div className="col-6 col-md-5  mb-0 pb-0 ">
                                    <label htmlFor="exampleInputEmail1" className="form-label">
                                        Problem
                                    </label>
                                    <div className="d-flex">
                                        {" "}
                                        <textarea
                                            className="form-control  w-100"
                                            autoComplete="off"
                                            type="text"
                                            rows={3}
                                            id="other-problem-name"
                                            placeholder="Problem"
                                            value={info?.problemName || ""}
                                            onChange={(e) => {
                                                setInfoFun("problemName", e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-6 col-md-7  mb-0 pb-0 ">
                                    <label htmlFor="exampleInputEmail1" className="form-label">
                                        Description
                                    </label>
                                    <div className="d-flex">
                                        {" "}
                                        <textarea
                                            className="form-control  w-100"
                                            autoComplete="off"
                                            type="text"
                                            rows={3}
                                            placeholder="Description"
                                            value={info.problemDescription || ""}
                                            onChange={(e) => {
                                                setInfoFun("problemDescription", e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="text-center  mt-3 d-flex w-100">
                                    <div className='mx-auto'>
                                        <button
                                            type="submit"
                                            className="btn submit-button  mx-auto"
                                        >
                                            {info?._id ? "Update info" : "Save info"}
                                            {isSubmitting && (
                                                <span
                                                    className="spinner-border spinner-border-sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                            )}
                                        </button>
                                        {info?._id && <button
                                            onClick={() => {
                                                setIsEditing(false)
                                                setInfo({})
                                            }}
                                            type="submit"
                                            className="btn submit-button  ml-2"
                                        >
                                            Reset
                                        </button>}
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                )}
            </Formik>

            <table className="table table-sm table-hover">
                <thead>
                    <tr>
                        <th scope="col">Date</th>
                        <th scope="col">Problem</th>
                        <th scope="col">Description</th>
                        <th scope="col">Action</th>
                        {/* <th scope="col">Note</th> */}
                    </tr>
                </thead>
                <tbody>
                    {noOtherHealthProblem ? (
                        <tr className="mx-2"><td>No previous history available</td></tr>
                    ) : (
                        otherProblems?.otherHealthProblem?.map((problem, index) => {
                            return (
                                <tr key={index} className={`${info?._id === problem?._id ? "common-font-color" : ""}`}>
                                    <td >{problem?.createdAt?.slice(0, 10)}</td>
                                    <td>{problem?.problemName}</td>
                                    <td>{problem?.problemDescription}</td>
                                    <td onClick={() => {
                                        setIsEditing(true)
                                        setEditFun(problem)
                                    }}><FontAwesomeIcon className='common-font-color ' size='sm' icon={faFilePen}></FontAwesomeIcon></td>
                                </tr>
                            );
                        })
                    )}
                    {isLoading && <tr><td className="mx-2">loading...</td></tr>}
                </tbody>
            </table>
        </div>
    )
}

export default OtherHealthProblem
